const multipleSaleText = {
  'multipleSaleText.withMultipleSale':
    'You must purchase at least {minSaleCount} pieces, and the quantity must be a multiple of {multipleSaleCount}',
  'multipleSaleText.withoutMultipleSale': 'You must purchase at least {minSaleCount} pieces',
  'multipleSaleText.withoutMinSaleCount': 'The quantity must be a multiple of {multipleSaleCount}',
};

export default multipleSaleText;
